import React from 'react';
import { Gift, X, Share2, Crown, ShieldCheck, Sparkles } from 'lucide-react';
import { UserProfile } from '../types';

interface ZereSeuAnoModalProps {
    isOpen: boolean;
    onClose: () => void;
    userProfile: UserProfile | null;
}

export const ZereSeuAnoModal: React.FC<ZereSeuAnoModalProps> = ({ 
    isOpen, 
    onClose, 
    userProfile
}) => {
    if (!isOpen || !userProfile) return null;

    // Use or generate a fallback code if the user doesn't have one in DB yet.
    // In ProfileView we should ensure they have one, but just in case:
    const referralCode = userProfile.referral_code || `${userProfile.id.substring(0, 8).toUpperCase()}`;
    const referralLink = `https://driverscore.space/?ref=${referralCode}`;
    
    const whatsappMessage = `Parceiro, dá uma olhada no Driver Score! É o aplicativo que eu uso pra auditar meus ganhos e não deixar dinheiro na mesa com os multiplicadores.\n\nSe você baixar por esse link, nós dois ganhamos 3 meses de proteção Premium grátis:\n${referralLink}`;
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(whatsappMessage)}`;

    return (
        <div className="fixed inset-0 z-[110] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300">
            <div className="bg-slate-900 border border-slate-700 w-full max-w-md rounded-3xl overflow-hidden shadow-2xl relative animate-in slide-in-from-bottom-8">
                {/* Header */}
                <div className="bg-gradient-to-br from-emerald-600 via-emerald-800 to-slate-900 p-8 pb-10 relative border-b border-emerald-500/30 overflow-hidden">
                    <div className="absolute top-0 right-0 p-4 z-10">
                        <button onClick={onClose} className="text-emerald-100 hover:text-white transition-colors bg-black/20 rounded-full p-1">
                            <X size={20} />
                        </button>
                    </div>

                    {/* Decorative elements */}
                    <div className="absolute top-1/2 left-0 w-full h-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-emerald-400/20 via-transparent to-transparent -translate-y-1/2"></div>
                    
                    <div className="flex flex-col items-center text-center space-y-4 relative z-10">
                        <div className="w-20 h-20 bg-gradient-to-br from-emerald-400 to-emerald-600 rounded-2xl flex items-center justify-center shadow-[0_0_40px_rgba(52,211,153,0.4)] animate-pulse-gentle">
                            <Gift size={40} className="text-white" />
                        </div>
                        <div>
                            <h2 className="text-2xl font-black text-white tracking-tight leading-tight flex items-center justify-center gap-2">
                                <Sparkles className="text-emerald-300" size={24} />
                                Zere o seu Ano!
                            </h2>
                        </div>
                    </div>
                </div>

                {/* Content */}
                <div className="p-8 space-y-6 bg-slate-900 relative">
                    <div className="text-center space-y-2">
                        <h3 className="text-lg font-bold text-white">Quer ganhar 1 ANO de Driver Score grátis?</h3>
                        <p className="text-slate-400 text-sm leading-relaxed">
                            E aí parceiro, tá gostando? Que tal compartilhar com um dos nossos colegas novatos?
                        </p>
                    </div>

                    <div className="bg-slate-800/80 border border-emerald-500/30 rounded-xl p-5 relative overflow-hidden">
                        <div className="absolute -right-6 -top-6 text-emerald-500/10">
                            <Crown size={100} />
                        </div>
                        <p className="text-sm text-emerald-100 font-medium relative z-10 leading-relaxed">
                            Indique um colega. Se ele assinar, <strong className="text-emerald-400 font-black">vocês dois ganham 3 meses grátis</strong> e protegem por mais tempo seus ganhos!
                        </p>
                        <p className="text-[10px] text-slate-500 mt-3 relative z-10 uppercase tracking-widest font-bold">
                            Limite de 4 indicações (12 meses)
                        </p>
                    </div>

                    <a
                        href={whatsappUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={onClose}
                        className="w-full bg-[#25D366] hover:bg-[#128C7E] active:scale-[0.98] text-white font-black py-4 px-6 rounded-2xl shadow-xl shadow-emerald-900/20 transition-all flex items-center justify-center gap-2 uppercase tracking-wide text-sm"
                    >
                        <Share2 size={20} />
                        Compartilhar no WhatsApp
                    </a>
                    
                    <button
                        onClick={onClose}
                        className="w-full text-slate-500 text-xs text-center hover:text-slate-400 transition-colors uppercase font-bold tracking-wider"
                    >
                        Talvez depois
                    </button>
                </div>
            </div>
        </div>
    );
};
